/* eslint-disable react/prefer-es6-class */
import React from 'react';
import ReactDOM from 'react-dom';
import Localization from 'es6/services/localization';

/**
 * A memoryBankPlot needs to be passed in, which is not a react component,
 * but handles rendering a SVG and manipulating it.
 *
 * NOTE: If you are planning to use this component, the underscore template
 *       in memory_bank/templates/tooltip must be on the page.
 */
export default React.createClass({
  displayName: 'MemoryBank',

  propTypes: {
    memoryBankPlot: React.PropTypes.object.isRequired,
    visual: React.PropTypes.oneOf([
      'progress',
      'difficulty',
    ]),
  },

  getDefaultProps() {
    return {
      visual: null,
    };
  },

  componentDidMount() {
    this._insertSVG();
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.props.memoryBankPlot !== prevProps.memoryBankPlot) {
      this._insertSVG();
    } else if (prevProps.visual !== this.props.visual) {
      this.props.memoryBankPlot.showVisual(this.props.visual);
    }
  },

  _insertSVG() {
    if (this.props.memoryBankPlot) {
      const domNode = ReactDOM.findDOMNode(this.refs.memoryBankLayer);

      // Remove previous memory bank if it exists.
      domNode.innerHTML = '';
      domNode.appendChild(this.props.memoryBankPlot.getSVG());

      this.props.memoryBankPlot.showVisual(this.props.visual);
    }
  },

  render() {
    return (
      <div className="memory-bank-root" id="memory-bank-component" data-visual={this.props.visual} >
        <section className="memory-bank-layer" ref="memoryBankLayer" />
        <section className="labels">
          <div className="label label-memory-strength">{Localization.t('memory-bank.y-axis')}</div>
        </section>
      </div>
    );
  },
});
